<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs :pt-5="$vuetify.breakpoint.lgAndUp">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-layout row wrap justify-center align-center pt-5 pb-10>
            <v-flex xs12 lg10>
              <v-card class="rounded-lg pt-7">
                <center>
                  <img
                    class="logo-cmp"
                    :src="require('@/assets/img/logoINETCMP.png')"
                    width="400"
                    alt=""
                  />
                </center>
                <v-card-text class="black--text" style="font-size: 16px">
                  <v-layout row wrap justify-center align-center pa-1>
                    <v-flex xs12 lg11>
                      <p class="pt-5">
                        <b>{{ $t("petition.text18") }} : </b> {{ SendCancelId }}
                      </p>

                      <v-card outlined>
                        <v-card-text
                          class="black--text"
                          style="font-size: 16px"
                        >
                          <p>
                            <b class="pb-2" style="font-size: 22px"
                              >รายละเอียดขอคำร้อง
                            </b>
                          </p>
                          <p><b>ชื่อ นามสกุล : </b> {{ NameTh }}</p>
                          <p><b>องค์กร : </b> {{ BusinessNameTh }}</p>
                          <p><b>หัวข้อนโยบาย : </b> {{ PolicyHeader }}</p>
                          <p><b>หัวข้อความยินยอม : </b></p>
                          <p v-for="(item, index) in Consent" :key="item.Level">
                            {{ index + 1 }}. {{ item.ConsentHeader }}
                          </p>
                          <!-- <p><b>ประเภทความยินยอม : </b> {{ SourceSystem }}</p> -->
                          <p><b>ประเภทคำร้อง : </b> {{ TypeName }}</p>
                          <p><b>ส่งคำร้องเมื่อ : </b> {{ CreatedAt }}</p>
                          <b>รายการข้อมูลที่ขอดำเนินการ :</b>
                          <v-card
                            class="ma-3"
                            outlined
                            color="grey lighten-4"
                            v-for="(item, i) in Tag"
                            :key="i"
                          >
                            <v-container>
                              <b class="mt-3">{{ item.Key }}</b>
                              <p>รายละเอียด: {{ item.ReqMessage }}</p>
                              <v-radio-group
                                :disabled="Status == 'finished'"
                                v-model="item.Status"
                                row
                                :rules="[(v) => !!v || 'กรุณาเลือก ความยินยอม']"
                              >
                                <v-radio
                                  label="ยืนยัน"
                                  value="approve"
                                ></v-radio>
                                <v-divider vertical></v-divider>
                                <v-radio
                                  class="ml-5"
                                  label="ปฏิเสธ"
                                  value="unapprove"
                                ></v-radio>
                              </v-radio-group>
                              <v-text-field
                                v-if="item.Status == 'unapprove'"
                                dense
                                outlined
                                label="ระบุเหตุผล"
                                :disabled="Status == 'finished'"
                                v-model="item.Reason"
                              ></v-text-field>
                            </v-container>
                          </v-card>
                          <!-- <p>
                            <b>สถานะ : </b>
                            <v-chip
                              color="green"
                              small
                              v-if="Status === 'approve'"
                              dark
                            >
                              ดำเนินการเรียบร้อยแล้ว</v-chip
                            >
                            <v-chip
                              color="red"
                              small
                              dark
                              v-else-if="Status === 'unapprove'"
                            >
                              ขอคำร้องไม่สำเร็จ</v-chip
                            >
                            <v-chip
                              color="warning"
                              small
                              dark
                              v-else-if="Status === 'pending'"
                            >
                              รอดำเนินการ</v-chip
                            >
                          </p> -->
                          <v-card class="ma-3" outlined color="grey lighten-4">
                            <v-container>
                              <v-layout row wrap justify-start align-baseline>
                                <v-flex
                                  xs6
                                  sm6
                                  md3
                                  lg2
                                  pa-3
                                  v-for="(item, i) in Files"
                                  :key="i"
                                >
                                  <v-hover>
                                    <template v-slot:default="{ hover }">
                                      <v-card
                                        @click="Fn_OpenFile(item)"
                                        style="cursor: pointer"
                                        outlined
                                        :elevation="hover ? 24 : 6"
                                        class="mx-auto rounded-xl"
                                      >
                                        <v-card-text class="text-center">
                                          <v-icon color="red" size="40"
                                            >mdi-file-pdf-box</v-icon
                                          >
                                        </v-card-text>
                                        <v-card-actions
                                          class="mt-n3"
                                          style="background: #fafafa"
                                        >
                                          <b class="text-truncate">
                                            {{ item.FileName }}
                                          </b>
                                        </v-card-actions>
                                      </v-card>
                                    </template>
                                  </v-hover>
                                </v-flex>
                              </v-layout>
                              <!-- <b class="mt-3">{{ item.FileName }}</b>
                            <p>รายละเอียด: {{ item.FileName }}</p> -->
                            </v-container>
                          </v-card>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                  <v-layout
                    row
                    wrap
                    justify-center
                    align-center
                    pt-4
                    pb-7
                    v-if="NameBtnSave === 'ยืนยันคำร้อง'"
                  >
                    <v-flex xs7 sm7 md2 lg2>
                      <v-btn color="#077893" dark block @click="Fn_Save">
                        {{ NameBtnSave }}</v-btn
                      >
                    </v-flex>
                    <v-flex xs7 sm7 md2 lg2 :ml-4="$vuetify.breakpoint.lgAndUp">
                      <v-btn color="#077893" outlined block @click="Fn_Cancle"
                        >ปฏิเสธคำร้อง</v-btn
                      >
                    </v-flex>
                  </v-layout>
                  <v-layout
                    row
                    wrap
                    justify-center
                    align-self-center
                    pb-4
                    v-else
                  >
                    <v-flex xs12 lg4 pt-4>
                      <v-alert border="left" dense text type="success">
                        {{ NameBtnSave }}
                      </v-alert>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-form>
      </v-container>
      <div v-if="loadingDownloadData">
        <OverlaySearch />
      </div>
      <DialogPreviewFile
        :show="DialogPreview"
        :_detail="ConsentDetail"
        @closeDialog="DialogPreview = false"
      />
    </v-main>
  </v-app>
</template>

<script>
import OverlaySearch from '@/components/layouts/LoadingPage.vue'
import DialogPreviewFile from "@/components/dialog/DialogPreviewFile.vue";
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: { DialogPreviewFile, OverlaySearch },
  data: function () {
    return {
      valid: true,
      ShowStatus: true,
      Consent: [],
      ConsentDetail: [],
      DialogPreview: false,
      DataConsentStatus: [],
      PolicyDetail: "",
      BusinessNameTh: "",
      AccessToken: "",
      ChatAccountId: "",
      Status: "",
      NameTh: "",
      NameEng: "",
      SendCancelId: "",
      BusinessName: "",
      ConsentHeader: "",
      PolicyHeader: "",
      SourceSystem: "",
      SubjectRequest: "",
      loadingDownloadData: false,
      DialogGeneral: false,
      NameBtnSave: "ยืนยันคำร้อง",
      Tag: "",
      Type: "",
      TypeName: "",
      Files: "",
    };
  },
  computed: {
    ...mapGetters(["DataGroupConsent"]),
    ...mapGetters(["Business"]),
    ...mapGetters(["RoleAccount"]),
    _RoleAccount: {
      get() {
        return this.RoleAccount || "-";
      },
    },
    _SendId: {
      get() {
        return this.DataGroupConsent.SendId || "-";
      },
    },
  },
  mounted() {
    this.Fn_GetToken();
  },
  methods: {
    async Fn_GetToken() {
      this.loadingDownloadData = true;
      var payload = {
        ShareToken: this.$route.path.split("/")[3],
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "token/login",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.AccessToken = response.data.Message.OneAccessToken;
            this.ChatAccountId = response.data.Message.OneAccountId;
            this.$cookies.set(
              "ChatAccountId",
              response.data.Message.OneAccountId
            );
            this.Fn_getDataConsent();
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_getDataConsent() {
      this.loadingDownloadData = true;
      var payload = {
        SendCancelId: this.$route.path.split("/")[2],
        AccessToken: this.AccessToken,
        Type: "Group",
      };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "business/Pettition/GetRequest",
          payload
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.BusinessNameTh = response.data.Message.BusinessNameTh;
            this.BusinessNameEng = response.data.Message.BusinessNameEng;
            this.TypeName = response.data.Message.TypeName;
            this.CreatedAt = response.data.Message.CreatedAt;
            this.CreatedAtEng = response.data.Message.CreatedAtEng;
            this.PolicyHeader = response.data.Message.PolicyHeader;
            this.PolicyDetail = response.data.Message.PolicyDetail;
            this.Status = response.data.Message.Status;
            this.SubjectRequest = response.data.Message.SubjectRequest;
            this.SendCancelId = response.data.Message.SendCancelId;
            this.NameTh = response.data.Message.NameTh;
            this.NameEng = response.data.Message.NameEng;
            this.Consent = response.data.Message.Consent;
            this.ConsentHeader = response.data.Message.ConsentHeader;
            this.Tag = response.data.Message.Tag;
            this.Files = response.data.Message.File;
            this.Type = response.data.Message.Type;
            if (
              this.Status === "approve" ||
              this.Status === "unapprove" ||
              this.Status === "finished"
            ) {
              this.NameBtnSave = "คำร้องนี้ได้ดำเนินการเรียบร้อยแล้ว";
              this.ShowStatus = false;
            } else {
              this.NameBtnSave = "ยืนยันคำร้อง";
              this.ShowStatus = true;
            }
          } else {
            window.close();
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          window.close();
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_Save() {
      if (this.$refs.form.validate()) {
        var payload = {
          AccessToken: this.AccessToken,
          SendCancelId: this.$route.path.split("/")[2],
          AccountId: this.ChatAccountId,
          Tag: this.Tag,
          Type: this.Type,
        };
        this.axios
          .post(
            process.env.VUE_APP_API_FACTORING_SERVICE +
              "business/Pettition/Confirm",
            payload
          )
          .then((response) => {
            this.loadingDownloadData = false;

            if (response.data.Status === "OK") {
              Toast.fire({
                icon: "success",
                title: this.$i18n.t("alert.confirm"),
              });
              this.NameBtnSave = this.$i18n.t("alert.list");
              this.ShowStatus = false;
              this.Fn_getDataConsent();
            } else {
              Toast.fire({
                icon: "error",
                title: response.data.ErrorMessage,
              });
            }
          })
          .catch((error) => {
            this.loadingDownloadData = false;
            if (error.response) {
              Toast.fire({
                icon: "error",
                title: error.response.data.ErrorMessage,
              });
            } else if (error.request) {
              Toast.fire({
                icon: "error",
                title: error.request,
              });
            } else {
              Toast.fire({
                icon: "error",
                title: error.message || error,
              });
            }
          });
      }
    },
    async Fn_OpenFile(item) {
      var headers = { Authorization: "Bearer " + this.AccessToken };
      this.axios
        .get(item.File, { headers })
        .then((response) => {
          if (response.data.Status === "OK") {
            this.ConsentDetail = response.data.Message;
            this.DialogPreview = true;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.Message.Status,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_Cancle() {
      window.close();
      this.$refs.formData.reset();
    },
  },
  watch: {},
};
</script>

<style>
td {
  border-style: hidden !important;
}
</style>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}

.bg-card {
  background-color: #eeeeee;
}
</style>
